module.exports = __webpack_public_path__ + "static/media/LCB_FishTankPinEndCard.d9eb80c6.png";